import { OV_API, getCertMetaInfoUrl } from '../constants/constants';

async function request(url, options = {}) {
  const res = await fetch(url, {
    credentials: 'same-origin',
    ...options,
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.reason || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return res.json();
}

export async function getSaleInfo(saleUuid) {
  const params = new URLSearchParams({ suid: saleUuid, my: 'me' });
  return request(`${OV_API.SALE_INFO}?${params}`);
}

export function createDraft(payload) {
  return request(OV_API.CREATE_DRAFT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function initiate(uuid, payload = {}) {
  return request(OV_API.INITIATE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ uuid, ...payload }),
  });
}

export function registerAttachment(verificationUuid, { saveName, originalFilename, fileSize, mimeType, fileType = 'other', phase = 'initial', reviewId = null }) {
  return request(OV_API.UPLOAD, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      verification_uuid: verificationUuid,
      file_location: saveName,
      original_filename: originalFilename,
      file_size: fileSize,
      mime_type: mimeType,
      file_type: fileType,
      phase,
      review_id: reviewId,
    }),
  });
}

export function getAddressByPnu(pnu) {
  const params = new URLSearchParams({ pnu });
  return request(`${OV_API.CERT_META_BY_PNU}?${params}`);
}

export async function loadCertMetaInfo(payload, maxRetries = 20) {
  const url = getCertMetaInfoUrl();
  const form = new FormData();
  form.append('pnu', payload.pnu || '');
  form.append('address', payload.address || '');
  form.append('service', payload.service || '');
  form.append('s_type', payload.s_type || '');
  form.append('selector', payload.selector || '');
  form.append('dong', payload.dong || '');
  form.append('floor', payload.floor || '');
  form.append('ho', payload.ho || '');

  const res = await fetch(url, { method: 'POST', body: form, credentials: 'same-origin' });
  if (!res.ok) throw new Error(`cert_meta_info: ${res.status}`);
  const data = await res.json();


  if (payload.service === 's_type' && data.msg === 'pending') {
    if (maxRetries <= 0) {
      throw new Error('cert_meta_info: 최대 재시도 횟수 초과 (pending)');
    }
    await new Promise(r => setTimeout(r, 1500));
    return loadCertMetaInfo(payload, maxRetries - 1);
  }
  return data;
}

export function getVerificationStatus(saleUuid, verificationUuid) {
  const params = new URLSearchParams({ sale_uuid: saleUuid });
  if (verificationUuid) params.set('verification_uuid', verificationUuid);
  return request(`${OV_API.STATUS}?${params}`);
}

export function listAttachments(verificationUuid) {
  const params = new URLSearchParams({ verification_uuid: verificationUuid });
  return request(`${OV_API.ATTACHMENTS}?${params}`);
}

export function resendLink(verificationUuid) {
  return request(OV_API.RESEND, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ verification_uuid: verificationUuid }),
  });
}

export function submitDispute({ uuid, reason }) {
  return request(OV_API.DISPUTE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ uuid, reason }),
  });
}

export function getLinkData(saleUuid) {
  const params = new URLSearchParams({ sale_uuid: saleUuid });
  return request(`${OV_API.LINK_DATA}?${params}`);
}
